import React from "react";
import Arbitrator from "./arbitrator/Arbitrator";

// IT dashboard → Arbitrators: the same screen as the Institution dashboard's
const ArbInfo = () => <Arbitrator />;

export default ArbInfo;
